function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "link");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.17,0A3.84,3.84,0,0,0,9.46,1.12l-3,3A5.36,5.36,0,0,1,7.17,4,5.11,5.11,0,0,1,9,4.39l1.86-1.85a1.83,1.83,0,0,1,2.58,2.58L10.12,8.46a1.86,1.86,0,0,1-2.58,0L6.12,9.88a3.84,3.84,0,0,0,5.42,0l3.34-3.34A3.83,3.83,0,0,0,12.17,0Z",
  transform: "translate(0 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7,11.63,5.12,13.47a1.83,1.83,0,0,1-2.59-2.59L5.88,7.54a1.86,1.86,0,0,1,2.58,0L9.88,6.12a3.93,3.93,0,0,0-5.42,0L1.12,9.46a3.83,3.83,0,0,0,5.42,5.42l2.94-2.94a4.76,4.76,0,0,1-.65.06A5,5,0,0,1,7,11.63Z",
  transform: "translate(0 0)"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.11df45ab.svg";
export { ForwardRef as ReactComponent };